import { Box, Divider, Theme, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import { TextTypeClass, textStyles } from "../../constants/TextTypes";

const useStyles = makeStyles((_theme: Theme) => ({
	...textStyles,
	textTypeBox: {
		padding: "12px 10px",
		margin: "4px -14px 6px -10px",
		"&:hover": {
			background: "rgba(83, 0, 201, 0.05)",
			boxShadow: "0px 4px 6px 0px rgba(83, 0, 201, 0.05)",
		},
	},
	disabledBox: {
		opacity: 0.4,
		pointerEvents: "none",
		cursor: "default",
	},
}));

interface IProps {
	textTypeClass: TextTypeClass;
	label: string;
	onClick: () => void;
	disabled?: boolean;
}

const TextBoxType = ({ textTypeClass, label, onClick, disabled }: IProps) => {
	const classes: any = useStyles();

	return (
		<>
			<Box
				className={clsx(classes.textTypeBox, { [classes.disabledBox]: disabled })}
				onClick={!disabled ? onClick : undefined}
			>
				<Typography className={classes[textTypeClass]}>{label}</Typography>
			</Box>
			<Divider />
		</>
	);
};

export default TextBoxType;
